import React, { Component } from "react";
import {
  ListaDadosProposta,
  ListaEmpresas,
  dadosParceiro,
  ListaItensPropostas,
  ListaConfigProdutos,
  ListaConfigEmbalagem,
  ListaTabelaPrecoEmbalagem,
  AtualizaDadosPedido,
  AtualizaQuantidadeProdutoPedido,
  inserirDadosProposta,
  ListaClientes,
  InserirFreteProposta,
  runVerificaAutenticacao,
  DeletePedidoFaturamento,
} from "../../../services/api";
import Header from "../../../components/Header";
//Components
import ScoreStepByStep from "../../../components/VendasPedidos/ComponentsPedidos/ScoreStepByStep";
import HeaderScreen from "../../../components/VendasPedidos/ComponentsPedidos/HeaderScreen";
import Title from "../../../components/VendasPedidos/ComponentsPedidos/Title.js";
import InfoBudget from "../../../components/VendasPedidos/ComponentsPedidos/InfoBudget.js";
import Loading from "../../../components/VendasPedidos/ComponentsPedidos/Loading.js";

//Screens
import BillingProducts from "../../../components/VendasPedidos/screens/BillingProducts";
import SelectBillingType from "../../../components/VendasPedidos/screens/SelectBillingType";
import BillingData from "../../../components/VendasPedidos/screens/BillingData";
import BillingShipping from "../../../components/VendasPedidos/screens/BillingShipping";
import BillingObservation from "../../../components/VendasPedidos/screens/BillingObservation";
import RequestedApproval from "../../../components/VendasPedidos/screens/RequestedApproval/index.jsx";
import {
  GenerateFindRequest,
  GenerateFindRequestResume,
  GenerateFindRequestResumeContent,
  GenerateFindRequestResumeContentFilter,
  GenerateFindRequestResumeContentFilterSelector,
  GenerateFindRequestResumeContentFilterSelectorButton,
  GenerateFindRequestResumeLoading,
  GenerateFindRequestResumeLoadingContent,
  GenerateFindRequestResumeSubtext,
  GenerateOrderContent,
  PedidosContainer,
} from "./styles";
import { Input, InputGroup, InputLeftAddon } from "@chakra-ui/react";

const loading = "/images/loading-blue.gif";

class GerarPedido extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_request: [],
      listCompany: [],
      company_select: [],
      data_client: [],
      data_delivery: [],
      data_product: [],
      data_proposal_original: [],
      step: 0,
      index_request: 0,
      updated_item: false,
      view_find_request: true,
      view_select_billing_type: false,
      view_billing_data: false,
      view_billing_products: false,
      view_billing_shipping: false,
      view_billing_observation: false,
      view_requested_approval: false,

      billing_type_more_than_one: false,
      data_proposal_changed: false,
      view_loading: false,
      codigo_proposta: null,
      codigo_usuario: JSON.parse(localStorage.getItem("authentication")).codigo_usuario,
      codigo_insert: parseInt(localStorage.getItem("codigo_insert")),
      codigo_vendedor: JSON.parse(localStorage.getItem("authentication")).codigo_vendedor,
    };
  }

  componentDidMount() {
    runVerificaAutenticacao();

    const queryParams = new URLSearchParams(window.location.search);

    const numero_proposta = queryParams.get("p");

    if (numero_proposta != null) {
      this.setState({ codigo_proposta: numero_proposta });
      this.filtrarPedido();
    }
  }

  filtrarPedido = async () => {
    await this.setState({ view_loading: true });
    localStorage.setItem("codigo_proposta", this.state.codigo_proposta);
    localStorage.setItem("codigo_insert", this.state.codigo_insert);
    await this.getDataProposal();
  };

  getDataProposal = async () => {
    try {
      var param = {
        codigo_proposta: parseInt(this.state.codigo_proposta),
        codigo_vendedor: parseInt(this.state.codigo_vendedor),
        codigo_tipo_operacao: 32,
      };

      const response = await ListaDadosProposta.post("", param);
      var data = response.data;

      console.log("RESPOSTA DO FILTRO", response);

      await this.setState({ data_request: data });
      var count = 0;

      for (let item of data) {
        item.companies = await this.getListCompanies(item);
        item.data_client = await this.getDataClient(item);
        item.data_delivery = await this.getDataDelivery(item);
        item.data_product = await this.getItens(item);
        this.state.data_request[count] = item;
        this.setState({ update: true });
        count++;
      }

      var count = 0;
      for await (let item of data) {
        item.original_itens = await this.getItensOriginal(item);
        this.setState({ update: true });
        count++;
      }

      if (Object.keys(this.state.data_request).length > 0) {
        this.setState({
          view_find_request: false,
          view_select_billing_type: false,
          view_billing_data: true,
          billing_type_more_than_one: true,
        });
      } else {
        alert("Pedido não encontrado.");

        this.setState({
          view_find_request: true,
          view_select_billing_type: false,
          view_billing_data: false,
          view_billing_products: false,
          view_billing_shipping: false,
          view_billing_observation: false,
          view_requested_approval: false,
        });
      }

      this.setState({ view_loading: false });
    } catch (error) {
      alert("Proposta não encontrada.");
      this.setState({ view_loading: false });
      console.log(Object.keys(error), error.message);
    }
  };

  sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if (new Date().getTime() - start > milliseconds) {
        break;
      }
    }
  }

  getItensOriginal = async (item) => {
    try {
      var param = {
        codigo_proposta: this.state.codigo_proposta,
        codigo_vendedor: "",
        codigo_tipo_operacao: 32,
      };
      const response = await ListaItensPropostas.post("", param);
      var data = response.data;

      var prod = [];

      this.state.data_request.map((req) => {
        req.data_product.map((item) => {
          prod.push({
            codprod: item.codigo_produto,
            sequencia: item.sequencia,
            qtd: parseInt(item.qtd_negociada),
          });
          item.select_amount = parseInt(item.qtd_negociada);
          item.total_amount = parseInt(item.qtd_negociada);
        });
      });

      for await (let obj of data) {
        for await (let p of prod) {
          if (p.codprod == obj.codigo_produto && p.sequencia == obj.sequencia) {
            if (isNaN(obj.total_amount)) {
              obj.total_amount = parseInt(obj.qtd_negociada);
            }
            obj.total_amount = obj.total_amount - p.qtd;
            this.setState({ update: true });
          }
        }
      }
      this.state.data_request.map((req) => {
        req.data_product.map((it) => {
          data.map((obj) => {
            if (obj.codigo_produto == it.codigo_produto && obj.sequencia == it.sequencia) {
              it.remaining_amount = obj.total_amount;
              it.total_amount = it.remaining_amount + parseInt(it.qtd_negociada);
              this.setState({ update: true });
            }
          });
        });
      });

      return data;
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  reloadDataProposal = async () => {
    try {
      var param = {
        codigo_proposta: parseInt(this.state.codigo_proposta),
        codigo_vendedor: parseInt(this.state.codigo_vendedor),
        codigo_tipo_operacao: 32,
      };

      const response = await ListaDadosProposta.post("", param);
      var data = response.data;

      await this.setState({ data_request: data });

      await this.setState({ view_loading: false });
    } catch (error) {
      alert("Proposta não encontrada.");
      this.setState({ view_loading: false });
      console.log(Object.keys(error), error.message);
    }
  };

  getListCompanies = async (obj) => {
    try {
      const response = await ListaEmpresas.get();
      var data = response.data;

      var company_select = [];

      data.map((emp) => {
        if (parseInt(emp.codigo_empresa) == parseInt(obj.codigo_empresa)) {
          company_select = emp;
        }
      });

      return { listCompany: data, company_select: company_select };
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getDataClient = async (obj) => {
    try {
      const response = await dadosParceiro.get(obj.codigo_parceiro + "/" + obj.codigo_contato);
      var dados = response.data;

      var data = await this.getInfoAddress(dados);
      await this.setState({ view_select_billing_type: true });
      return data.data_client;
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getDataDelivery = async (obj) => {
    try {
      const response = await dadosParceiro.get(obj.codigo_parceiro_destino);
      var dados = response.data;

      var data = await this.getInfoAddressDelivery(dados);
      return data.data_delivery;
    } catch (error) {
      const response = await dadosParceiro.get(obj.codigo_parceiro);
      var dados = response.data;

      var data = await this.getInfoAddressDelivery(dados);
      return data.data_delivery;
    }
  };

  getInfoAddress = async (obj) => {
    try {
      var CEP_API = await fetch(`https://viacep.com.br/ws/${obj.cep}/json/`);
      var CEP_API_REST = await CEP_API.json();

      var data_client = obj;

      data_client.bairro = CEP_API_REST.bairro;
      data_client.municipio = CEP_API_REST.localidade;
      data_client.uf = CEP_API_REST.uf;
      data_client.logradouro = CEP_API_REST.logradouro;

      return { data_client: data_client };
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getInfoAddressDelivery = async (obj) => {
    try {
      var CEP_API = await fetch(`https://viacep.com.br/ws/${obj.cep}/json/`);
      var CEP_API_REST = await CEP_API.json();

      var data_delivery = obj;

      data_delivery.bairro = CEP_API_REST.bairro;
      data_delivery.municipio = CEP_API_REST.localidade;
      data_delivery.uf = CEP_API_REST.uf;
      data_delivery.logradouro = CEP_API_REST.logradouro;

      return { data_delivery: data_delivery };
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getItens = async (obj) => {
    try {
      var param = {
        codigo_proposta: this.state.codigo_proposta,
        codigo_vendedor: "",
        numero_nota: obj.numero_nota,
        codigo_tipo_operacao: 32,
      };
      const response = await ListaItensPropostas.post("", param);
      var data = response.data;

      for await (let item of data) {
        if (item.token_embalagem != null && item.tipo_produto == "PROD") {
          for await (let obj of data) {
            if (obj.token_embalagem == item.token_embalagem && obj.tipo_produto == "EMB") {
              const response = await ListaConfigEmbalagem.post("", {
                codigo_produto: obj.codigo_produto,
                quantidade: item.qtd_negociada,
                prazo: item.id_prazo_entrega,
              });
              var result = response.data;

              const dadosEmbalagem = await ListaConfigProdutos.get(obj.codigo_produto);
              var dados_embalagem = dadosEmbalagem.data;

              var tipo = [];
              var cores = [];
              result.map((data) => {
                tipo.push({
                  codigo_impressao: data.codigo_impressao,
                  descricao_impressao: data.descricao,
                });
                cores.push({
                  codigo_cor: data.codigo_cor,
                  descricao_cor: data.nome_cor,
                  imagem_box: data.imagem_box,
                  imagem_print: data.imagem_print,
                  imagem_plus: data.imagem_plus,
                });

                dados_embalagem.valor_total = parseFloat(data.CubagemTotal);
                dados_embalagem.valor_unitario = parseFloat(data.CubagemUnitaria);
              });

              var tipoUniqueArray = tipo.filter((tip, index) => {
                const _tip = JSON.stringify(tip);
                return (
                  index ===
                  tipo.findIndex((obj) => {
                    return JSON.stringify(obj) === _tip;
                  })
                );
              });

              var corUniqueArray = cores.filter((cor, index) => {
                const _cor = JSON.stringify(cor);
                return (
                  index ===
                  cores.findIndex((obj) => {
                    return JSON.stringify(obj) === _cor;
                  })
                );
              });

              tipo = tipoUniqueArray;
              cores = corUniqueArray;
              var cubagem = result[0];

              var valor_por_tipo = await this.getInfosEmbalagem(obj);

              tipo.map((tip, idx) => {
                tip.valor = valor_por_tipo.valores_embalagem[idx];
              });

              item.cores_embalagem = cores;
              item.gravacao_embalagem = tipo;

              await this.setState({ update: true });

              cores.map((data) => {
                if (data.codigo_cor == obj.id_cor) {
                  item.codigo_cor_embalagem_selecionada = data;
                }
              });

              tipo.map((data) => {
                if (data.codigo_impressao == obj.id_impressao) {
                  item.codigo_impressao_embalagem_selecionada = data;
                }
              });

              await this.setState({ update: true });

              item.cubagem_embalagem = cubagem;
              item.dados_embalagem = dados_embalagem;

              await this.setState({ update: true });
            }
          }
        }
      }
      this.setState({ view_select_billing_type: true });
      return data;
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getInfosEmbalagem = async (data) => {
    try {
      var codprod = data.codigo_produto;

      const response = await ListaTabelaPrecoEmbalagem.get(codprod + "/tipo-gravacao");
      var dados = await response.data;

      if (dados[0].descricao_produto.trim() == "EMBALAGEM PARA CANETA") {
        this.setState({ tipo_embalagem: "caneta" });
      } else {
        this.setState({ tipo_embalagem: "box" });
      }

      var qtd = parseInt(data.qtd_negociada);
      var prazo = parseInt(data.id_prazo_entrega);

      var valores = [];
      var valoresTotais = [];
      var altura = [];
      var largura = [];
      var comprimento = [];
      var peso = [];
      var qtdcaixa = [];
      var codigo_impressao = [];

      for (var d of dados) {
        const response = await ListaTabelaPrecoEmbalagem.post("listar-tabela-preco/" + codprod + "/" + qtd, {
          ad_embalagem: codprod,
          codigo_impressao: d.codigo_impressao,
          prazo_entrega: prazo,
          codigo_cor: 1,
          batidas: 1,
        });
        var dados = await response.data[0];
        if (dados.mensagem != null) {
          var valor = dados.mensagem.split(",");
        } else {
          var valor = [];
        }

        codigo_impressao.push(d.codigo_impressao);

        for (var v of valor) {
          if (v.indexOf("ValorVenda") != -1) {
            valores.push(v.replace("ValorVenda=", "").replace(".", ","));
          }
          if (v.indexOf("ValorTotalVenda") != -1) {
            valoresTotais.push(v.replace("ValorTotalVenda=", "").replace(".", ","));
          }
          if (v.indexOf("Altura") != -1) {
            altura.push({ valor: v.replace("Altura=", "").replace(".", ",") });
          }
          if (v.indexOf("Largura") != -1) {
            largura.push({
              valor: v.replace("Largura=", "").replace(".", ","),
            });
          }
          if (v.indexOf("Comprimento") != -1) {
            comprimento.push({
              valor: v.replace("Comprimento=", "").replace(".", ","),
            });
          }
          if (v.indexOf("PesoCaixa") != -1) {
            peso.push({ valor: v.replace("PesoCaixa=", "").replace(".", ",") });
          }
          if (v.indexOf("QtdCaixa") != -1) {
            qtdcaixa.push({
              valor: v.replace("QtdCaixa=", "").replace(".", ","),
            });
          }
        }
      }

      return {
        valores_embalagem: valores,
        valores_embalagem_total: valoresTotais,
        altura_embalagem: altura[0],
        largura_embalagem: largura[0],
        comprimento_embalagem: comprimento[0],
        peso_embalagem: peso[0],
        qtd_caixa_embalagem: qtdcaixa[0],
        codigo_impressao_embalagem: codigo_impressao,
      };
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  changeInputField = async (e, value) => {
    this.setState({ [value]: e.target.value });
    if (e.key == "Enter") {
      this.filtrarPedido();
    }
  };

  updateData = async (data, obj) => {
    if (obj == "company") {
      this.state.data_request[this.state.index_request].companies.company_select = data;
      this.setState({ company_select: data, data_proposal_changed: true });
    } else if (obj == "customer") {
      this.state.data_request[this.state.index_request].data_client = data;
      this.setState({ data_client: data, data_proposal_changed: true });
    } else if (obj == "delivery") {
      this.state.data_request[this.state.index_request].data_delivery = data;
      this.setState({ data_delivery: data, data_proposal_changed: true });
    } else if (obj == "shipping") {
      this.state.data_request[this.state.index_request].data_delivery = data;
      this.setState({ data_delivery: data });
    }
  };

  updateDataProposal = async (e, value) => {
    this.state.data_request[this.state.index_request][value] = e.target.value;

    // if(value == "valor_real_frete"){
    // this.state.data_request[this.state.index_request].valor_cotacao_frete = parseFloat(e.target.value) + ((parseFloat(e.target.value)*30)/100);
    // }
    this.setState({ update: true });
  };

  billingTypeOne = async () => {
    this.setState({
      view_select_billing_type: false,
      view_billing_data: true,
      billing_type_more_than_one: false,
    });
  };

  billingTypeMoreThanOne = async () => {
    this.setState({
      view_select_billing_type: false,
      view_billing_data: true,
      billing_type_more_than_one: true,
    });
  };

  saveDataProposal = async () => {
    if (this.state.data_proposal_changed) {
      try {
        this.setState({ view_loading: true });
        var param = {
          numero_nota: parseInt(this.state.data_request[this.state.index_request].numero_nota),
          numero_pedido: parseInt(this.state.data_request[this.state.index_request].numero_proposta),
          codigo_empresa: parseInt(
            this.state.data_request[this.state.index_request].companies.company_select.codigo_empresa
          ),
          codigo_parceiro: parseInt(this.state.data_request[this.state.index_request].data_client.codigo_parceiro),
          codigo_contato: parseInt(this.state.data_request[this.state.index_request].data_client.codigo_contato),
          codigo_parceiro_destino: parseInt(
            this.state.data_request[this.state.index_request].data_delivery.codigo_parceiro
          ),
        };

        const response = await AtualizaDadosPedido.post("", param);
        var data = response.data;

        if ((data.status = "sucesso")) {
          this.setState({ view_loading: false, data_proposal_changed: false });
          this.setState({
            view_billing_products: true,
            updated_item: false,
            view_billing_data: false,
            step: 2,
          });
        } else {
          alert("Erro ao atualizar dados do faturamento.");
        }
      } catch (error) {
        alert("Erro ao atualizar dados do faturamento.");
        console.log(Object.keys(error), error.message);
      }
    } else {
      this.setState({
        view_billing_products: true,
        view_billing_data: false,
        step: 2,
      });
    }
  };

  updateItem = async (item) => {
    try {
      var param = {
        numero_nota: item.numero_nota,
        numero_pedido: this.state.codigo_proposta,
        codigo_produto: item.codigo_produto,
        sequencia: item.sequencia,
        quantidade: item.select_amount,
      };

      const response = await AtualizaQuantidadeProdutoPedido.post("", param);
      var data = response.data;
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };
  saveDataProduct = async () => {
    this.setState({ view_loading: true });

    if (this.state.updated_item) {
      var itens = this.state.data_request[this.state.index_request].data_product;
      for await (let item of itens) {
        await this.updateItem(item);
      }

      await this.setState({
        view_billing_products: false,
        data_request: [],
        listCompany: [],
        company_select: [],
        data_client: [],
        data_delivery: [],
        data_product: [],
        data_proposal_original: [],
      });
      await this.filtrarPedido();
      this.setState({
        view_find_request: false,
        view_select_billing_type: false,
        view_billing_data: false,
        view_billing_products: false,
        view_billing_shipping: false,
        view_billing_observation: false,
        view_requested_approval: false,
      });
    }

    this.setState({
      view_billing_products: false,
      view_billing_shipping: true,
      step: 3,
      view_loading: false,
    });
  };

  ifnull = (a, b) => {
    if (a == undefined || a == null || a == "") {
      return b;
    } else {
      return a;
    }
  };

  saveObservation = async () => {
    if (this.state.billing_type_more_than_one) {
      var missing_items = false;
      this.state.data_request.map((req) => {
        req.data_product.map((item) => {
          if (parseInt(item.qtd_negociada) < item.total_amount) {
            missing_items = true;
          }
        });
      });

      if (missing_items) {
        alert("Itens em aberto, abriremos um novo pedido para a quantidade restante.");
        var param = {
          codigo_proposta: parseInt(this.state.codigo_proposta),
          codigo_vendedor: parseInt(this.state.codigo_vendedor),
          codigo_tipo_operacao: 33,
        };

        const response = await ListaDadosProposta.post("", param);
        var data = response.data;

        this.setState({
          view_find_request: false,
          view_select_billing_type: false,
          view_billing_data: false,
          view_billing_products: false,
          view_billing_shipping: false,
          view_billing_observation: false,
          view_requested_approval: false,
          view_loading: true,
        });
        var cab = {
          sequencia: "0",
          codigo_parceiro: this.ifnull(this.state.data_request[this.state.index_request].codigo_parceiro, ""),
          observacao_cliente: this.ifnull(this.state.data_request[this.state.index_request].observacao_cliente, ""),
          codigo_produto: "",
          quantidade_negociada: "",
          valor_unitario: "",
          valor_total: "",
          preco_base: "",
          id_impressao: "",
          id_cor: "",
          id_prazo_entrega: "",
          qtd_batidas: "",
          frete_site: "",
          numero_nota: "",
          email: this.ifnull(this.state.data_request[this.state.index_request].email_contato, "").trim(),
          contato_site: "",
          codigo_vendedor: this.ifnull(this.state.data_request[this.state.index_request].codigo_vendedor, ""),
          codigo_contato: this.ifnull(this.state.data_request[this.state.index_request].codigo_contato, ""),
          proposta_especial: this.state.data_request[this.state.index_request].proposta_especial,
          estimativa_valor: this.ifnull(data.estimativa_valor, ""),
          codigo_tipo_operacao: "32",
          codigo_tipo_venda: this.ifnull(this.state.data_request[this.state.index_request].codigo_tipo_venda, ""),
          codigo_empresa: this.ifnull(data.codigo_empresa, ""),
          observacao: this.ifnull(this.state.data_request[this.state.index_request].observacao, ""),
          observacao_interna: this.ifnull(this.state.data_request[this.state.index_request].observacao_cliente, ""),
          observacao_detalhada_proposta: this.ifnull(
            this.state.data_request[this.state.index_request].detalhe_proposta,
            ""
          ),
          perdido: "",
          observacao_perda: "",
          observacao_item: "",
          negociacao_perdida: "",
          status_produto_aprovado: "",
          utiliza_preco_site: "",
          id_formato: "",
          id_material: "",
          id_acabamento: "",
          id_borda: "",
          id_extra: "",
          id_tipo_corte: "",
          status_qualificacao: this.ifnull(this.state.data_request[this.state.index_request].qualificacao_st, ""),
          percentual_comissao: "",
          codigo_parceiro_transportadora: "",
          via_transportadora: "",
          tipo_frete: "",
          valor_frete: "",
          cotacao_frete: "",
          valor_real_frete: "",
          codigo_parceiro_destino: this.state.data_request[this.state.index_request].codigo_parceiro_destino,
          numero_nota_original: this.ifnull(data.numero_nota, ""),
          sequencia_original: "0",
        };
        const responseCab = await inserirDadosProposta.post("", cab);
        var resultCab = responseCab.data;

        var proposta = this.state.data_request[this.state.index_request];

        for await (let item of this.state.data_request[this.state.index_request].data_product) {
          var produto = {
            id: null,
            codigo_contato: proposta.codigo_contato,
            codigo_empresa: proposta.codigo_empresa,
            codigo_parceiro: proposta.codigo_parceiro,
            codigo_parceiro_destino: proposta.codigo_parceiro_destino,
            codigo_parceiro_transportadora: proposta.codigo_parceiro_transporte,
            codigo_produto: item.codigo_produto,
            codigo_tipo_operacao: 32,
            codigo_tipo_venda: proposta.codigo_tipo_venda,
            codigo_vendedor: this.state.codigo_vendedor,
            email: proposta.email_contato,
            estimativa_valor: proposta.estimativa_valor,
            id_cor: item.id_cor,
            id_impressao: item.id_impressao,
            id_prazo_entrega: item.id_prazo_entrega,
            nao_exibe_proposta: item.nao_exibe_proposta,
            negociacao_perdida: item.negocped,
            numero_nota: resultCab.NUNOTA,
            observacao: proposta.observacao,
            observacao_cliente: proposta.observacao_cliente,
            observacao_detalhada_proposta: proposta.detalhe_proposta,
            observacao_interna: proposta.observacao_admin,
            observacao_item: item.observacao,
            observacao_perda: proposta.observacao_perda,
            percentual_comissao: item.perccom,
            preco_base: Math.round(parseFloat(item.preco_base) * 100) / 100,
            proposta_especial: proposta.proposta_especial,
            qtd_batidas: item.qtd_batida,
            quantidade_negociada: 1,
            sequencia: item.sequencia,
            status_produto_aprovado: item.status_produto_aprovacao,
            status_qualificacao: proposta.qualificacao_st,
            tipo_frete: proposta.tipo_frete,
            token_embalagem: item.token_embalagem,
            utiliza_preco_site: item.utiliza_preco_site,
            valor_frete: proposta.valor_frete,
            valor_frete_item: item.valor_frete,
            valor_total: Math.round(parseFloat(item.valor_total) * 100) / 100,
            valor_unitario: Math.round(parseFloat(item.valor_unitario) * 100) / 100,
            frete_site: item.frete_selecionado == undefined ? item.frete_site : item.frete_selecionado,
            numero_nota_original: data.numero_nota,
            sequencia_original: item.sequencia,
          };

          var responseProd = await inserirDadosProposta.post("", produto);
          var resultProd = responseProd.data;
        }

        var idx = this.state.data_request.length;

        await this.setState({
          view_billing_data: false,
          index_request: idx,
          data_request: [],
          listCompany: [],
          company_select: [],
          data_client: [],
          data_delivery: [],
          data_product: [],
          data_proposal_original: [],
        });
        await this.filtrarPedido();

        this.setState({
          view_loading: false,
          view_select_billing_type: false,
          view_billing_data: true,
        });
      } else {
        this.setState({
          view_billing_observation: false,
          view_requested_approval: true,
          step: 5,
        });
      }
    } else {
      this.setState({
        view_billing_observation: false,
        view_requested_approval: true,
        step: 5,
      });
    }
  };

  saveDataShipping = async () => {
    var delivery = this.state.data_request[this.state.index_request].data_delivery;
    var proposal = this.state.data_request[this.state.index_request];
    try {
      const response = await InserirFreteProposta.post("", {
        numero_nota: proposal.numero_nota,
        codigo_parceiro_transportadora: null,
        via_transportadora: "",
        tipo_frete: "",
        valor_frete: proposal.valor_frete,
        cotacao_frete: proposal.numero_cotacao_frete,
        valor_real_frete: parseFloat(proposal.valor_cotacao_frete),
        codigo_parceiro_destin: proposal.data_delivery.codigo_parceiro,
      });
      var data = response.data;

      if (data.result) {
        this.setState({
          view_billing_shipping: false,
          view_billing_observation: true,
          step: 4,
        });
      } else {
        alert(data.mensagem);
      }
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  selectBilling = async (e) => {
    await this.setState({
      view_billing_data: false,
      index_request: parseInt(e.target.attributes.data.value),
      // data_request: [],
      // listCompany: [],
      // company_select: [],
      // data_client: [],
      // data_delivery: [],
      // data_product: [],
      // data_proposal_original: [],
    });
    // await this.filtrarPedido();
    this.setState({ view_find_request: false, view_billing_data: true });
    this.setState({ view_find_request: false });
    this.setState({ view_billing_data: true });
  };

  backToBudget = async () => {
    if (window.confirm("Todos os faturamentos para este pedido seram deletados. Deseja continuar?")) {
      this.setState({ view_loading: true });
      try {
        const response = await DeletePedidoFaturamento.post("", { numero_pedido: this.state.codigo_proposta });
        var data = response.data;

        if (data.result) {
          window.location.href = "/orcamento?p=" + this.state.codigo_proposta;
        } else {
          this.setState({ view_loading: false });
          alert("Erro ao voltar pedido para orçamento.");
        }
      } catch (error) {
        this.setState({ view_loading: false });
        alert("Erro ao voltar pedido para orçamento.");
        console.log(Object.keys(error), error.message);
      }
    }
  };

  deleteBilling = async (e) => {
    if (this.state.data_request.length == 1) {
      this.backToBudget();
    } else if (this.state.data_request.length > 1) {
      var idx = e.target.attributes.data.value;
      this.setState({ view_loading: true });

      try {
        const response = await DeletePedidoFaturamento.post("", {
          numero_pedido: this.state.data_request[idx].numero_proposta,
          numero_nota: this.state.data_request[idx].numero_nota,
        });
        var data = response.data;

        if (data.result) {
          this.setState({
            data_request: [],
            listCompany: [],
            company_select: [],
            data_client: [],
            data_delivery: [],
            data_product: [],
            data_proposal_original: [],
            step: 0,
            index_request: 0,
            updated_item: false,
            view_find_request: false,
            view_select_billing_type: false,
            view_billing_data: false,
            view_billing_products: false,
            view_billing_shipping: false,
            view_billing_observation: false,
            view_requested_approval: false,
          });

          await this.getDataProposal();
          this.setState({
            view_find_request: false,
            view_select_billing_type: false,
            view_billing_data: true,
            view_billing_products: false,
            view_billing_shipping: false,
            view_billing_observation: false,
            view_requested_approval: false,
            view_loading: false,
          });
        } else {
          this.setState({ view_loading: false });
          alert("Erro ao voltar pedido para orçamento.");
        }
      } catch (error) {
        this.setState({ view_loading: false });
        alert("Erro ao voltar pedido para orçamento.");
        console.log(Object.keys(error), error.message);
      }
    }
  };

  render() {
    return (
      <>
        <PedidosContainer>
          <GenerateOrderContent>
            {this.state.view_loading ? <Loading view_loading={this.state.view_loading} /> : <></>}

            {this.state.view_find_request ? (
              <FindRequest
                data={this.state}
                changeInputField={this.changeInputField}
                filtrarPedido={this.filtrarPedido}
              />
            ) : (
              <>
                <HeaderScreen />

                {this.state.view_select_billing_type ? <Title /> : <></>}

                <ScoreStepByStep step={this.state.step} />

                <InfoBudget codigo_proposta={this.state.codigo_proposta} backToBudget={this.backToBudget} />
              </>
            )}

            {this.state.view_select_billing_type ? (
              <SelectBillingType
                billingTypeOne={this.billingTypeOne}
                billingTypeMoreThanOne={this.billingTypeMoreThanOne}
              />
            ) : null}

            {this.state.view_billing_data ? (
              <BillingData
                data_request={[this.state.data_request[this.state.index_request]]}
                all_request={this.state.data_request}
                company_select={this.state.data_request[this.state.index_request].companies.company_select}
                data_client={this.state.data_request[this.state.index_request].data_client}
                data_delivery={this.state.data_request[this.state.index_request].data_delivery}
                index_request={this.state.index_request + 1}
                selectBilling={this.selectBilling}
                deleteBilling={this.deleteBilling}
                updateData={this.updateData}
                continue={() => this.saveDataProposal()}
                back={() =>
                  this.setState({
                    view_billing_data: false,
                    view_select_billing_type: true,
                    step: 1,
                  })
                }
              />
            ) : null}

            {this.state.view_billing_products ? (
              <BillingProducts
                data_request={this.state.data_request[this.state.index_request].data_product}
                all_request={this.state.data_request}
                data_proposal_original={this.state.data_request[this.state.index_request].original_itens}
                billing_type_more_than_one={this.state.billing_type_more_than_one}
                index_request={this.state.index_request + 1}
                updated_item={() => this.setState({ updated_item: true })}
                continue={() => this.saveDataProduct()}
                back={() =>
                  this.setState({
                    view_billing_products: false,
                    view_billing_data: true,
                    step: 1,
                  })
                }
              />
            ) : null}

            {this.state.view_billing_shipping ? (
              <BillingShipping
                data_request={this.state.data_request[this.state.index_request].data_product}
                data_delivery={this.state.data_request[this.state.index_request].data_delivery}
                data_proposal={this.state.data_request[this.state.index_request]}
                index_request={this.state.index_request + 1}
                updateData={this.updateData}
                updateDataProposal={this.updateDataProposal}
                continue={() => this.saveDataShipping()}
                back={() =>
                  this.setState({
                    view_billing_products: true,
                    view_billing_shipping: false,
                    step: 2,
                  })
                }
              />
            ) : null}

            {this.state.view_billing_observation ? (
              <BillingObservation
                data_request={[this.state.data_request[this.state.index_request]]}
                all_request={this.state.data_request}
                company_select={this.state.data_request[this.state.index_request].companies.company_select}
                data_client={this.state.data_request[this.state.index_request].data_client}
                data_delivery={this.state.data_request[this.state.index_request].data_delivery}
                index_request={this.state.index_request + 1}
                continue={() => this.saveObservation()}
                back={() =>
                  this.setState({
                    view_billing_shipping: true,
                    view_billing_observation: false,
                    step: 3,
                  })
                }
              />
            ) : null}

            {this.state.view_requested_approval ? (
              <RequestedApproval
                data_request={[this.state.data_request[this.state.index_request]]}
                all_request={this.state.data_request}
                company_select={this.state.data_request[this.state.index_request].companies.company_select}
                data_client={this.state.data_request[this.state.index_request].data_client}
                data_delivery={this.state.data_request[this.state.index_request].data_delivery}
                data_product={this.state.data_request[this.state.index_request].data_product}
                index_request={this.state.index_request + 1}
                selectBilling={() => {}}
                back={() =>
                  this.setState({
                    view_billing_observation: true,
                    view_requested_approval: false,
                    step: 4,
                  })
                }
                edit={(idx) =>
                  this.setState({
                    view_billing_data: true,
                    view_requested_approval: false,
                    step: 1,
                    index_request: idx - 1,
                  })
                }
              />
            ) : null}
          </GenerateOrderContent>
        </PedidosContainer>
      </>
    );
  }
}

export default GerarPedido;

function FindRequest(data) {
  return (
    <GenerateFindRequest>
      <GenerateFindRequestResume>
        <GenerateFindRequestResumeLoading style={data.view_loading ? { display: "block" } : { display: "none" }}>
          <GenerateFindRequestResumeLoadingContent>
            <img alt="img" src={loading} />
          </GenerateFindRequestResumeLoadingContent>
        </GenerateFindRequestResumeLoading>
        <GenerateFindRequestResumeContent>
          <GenerateFindRequestResumeContentFilter>
            <GenerateFindRequestResumeContentFilterSelector>
              <InputGroup>
                <InputLeftAddon bgColor="#ff7e00" color="white" children="Nº PEDIDOS:" />
                <Input
                  focusBorderColor="#ff7e00"
                  bgColor="white"
                  autoFocus
                  placeholder="Digite o número..."
                  name="numero_proposta"
                  type="text"
                  onChange={(e) => data.changeInputField(e, "codigo_proposta")}
                  onKeyPressCapture={(e) => data.changeInputField(e, "codigo_proposta")}
                />
              </InputGroup>
            </GenerateFindRequestResumeContentFilterSelector>
            <GenerateFindRequestResumeContentFilterSelectorButton onClick={() => data.filtrarPedido()}>
              BUSCAR
            </GenerateFindRequestResumeContentFilterSelectorButton>
          </GenerateFindRequestResumeContentFilter>
        </GenerateFindRequestResumeContent>
      </GenerateFindRequestResume>
      <GenerateFindRequestResume>
        <GenerateFindRequestResumeSubtext>
          <h1>Informa o número único para carregamento dos dados do pedido.</h1>
        </GenerateFindRequestResumeSubtext>
      </GenerateFindRequestResume>
    </GenerateFindRequest>
  );
}
